import { Color, SRGBColorSpace, TextureLoader, Vector2, Vector3 } from 'three';
export const convertDocToThreeEmitterSettings = (settings) => {
    const newSettings = JSON.parse(JSON.stringify(settings));
    for (const k in newSettings) {
        const key = k;
        if (key === 'position' || key === 'velocity' || key === 'rotation' || key === 'acceleration') {
            const propertySettings = newSettings[key];
            if (!propertySettings)
                continue;
            for (const k in propertySettings) {
                const key = k;
                if (Array.isArray(propertySettings[key])) {
                    propertySettings[key] = new Vector3(...propertySettings[key]);
                }
            }
        }
        if (key === 'color') {
            const colorSettings = newSettings[key];
            const value = colorSettings?.value;
            const spread = colorSettings?.spread;
            if (value) {
                colorSettings['value'] = Array.isArray(value) ? value.map((col) => new Color(col).convertSRGBToLinear()) : new Color(value).convertSRGBToLinear();
            }
            if (spread) {
                colorSettings['spread'] = Array.isArray(spread[0]) ? spread.map((col) => new Vector3(...col)) : new Vector3(...spread);
            }
        }
    }
    return newSettings;
};
export const convertDocToThreeEmitterGroupSettings = (settings) => {
    const newSettings = JSON.parse(JSON.stringify(settings));
    if (newSettings.texture?.frames) {
        newSettings.texture.frames = new Vector2(...newSettings.texture.frames);
    }
    if (newSettings.texture?.value) {
        newSettings.texture.value = new TextureLoader().load(newSettings.texture.value);
        newSettings.texture.value.colorSpace = SRGBColorSpace;
    }
    return newSettings;
};
